// extracted by mini-css-extract-plugin
export default {"userFollowNftsItem":"mif6JcUaVDqMdeDkQzS4"};